import React, { Component } from 'react';
import { connect } from 'react-redux';
import NewIncidentDialog from './NewIncidentDialog';
import { history } from '../../index';

class Main extends Component {

  render() {

    return (
      <NewIncidentDialog
        open={true}
        onNewIncidentClose={() =>
        {
          history.push('/incidents');
       }}/>
    )
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  map: state.map
})

/*const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...conflictOperations
  }, dispatch);
}*/

export default connect(mapStateToProps)(Main)
